// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__7YYu5","resendInfoText":"OnGoingPaymentBox_resendInfoText__3yfpG"};